import { useBreakpoints } from '@hub/hooks/useBreakpoints';
import type { MainMenuItem } from '@hub/layout/MainMenu/MainMenu';
import { DeliveryLocationBanner } from '@hub/layout/DeliveryLocationBanner/DeliveryLocationBanner';
import { LeadInBanner } from '@hub/layout/LeadInBanner/LeadInBanner';
import type { DeliveryLocationBannerContent } from '@hub/libs/deliverylocation-banner.helper';
import type { ContactAreaType } from '@hub/models/api/contact-area-type.types';
import type { LeadIn } from '@hub/models/api/page-content.types';
import type { LanguageAlternate } from '@hub/models/data';
import type { ProductFragmentEnhanced } from '@hub/models/enhanced-fragments';
import { Header } from './Header';
import { MainMenu } from '@hub/layout/MainMenu/MainMenu';

export type HeaderProps = {
  deliveryLocationBannerContent: DeliveryLocationBannerContent | null;
  leadIn: LeadIn | null;
  mainMenuItems: MainMenuItem[];
  contactAreaType: ContactAreaType | null;
  languageAlternates: ReadonlyArray<LanguageAlternate>;
  currentProduct?: ProductFragmentEnhanced;
};

export const LegacyHeader = ({
  deliveryLocationBannerContent,
  leadIn,
  mainMenuItems,
  contactAreaType,
  languageAlternates,
  currentProduct,
}: HeaderProps) => {
  const { lg, available } = useBreakpoints();

  return (
    <>
      {deliveryLocationBannerContent && (
        <DeliveryLocationBanner
          title={deliveryLocationBannerContent.title}
          text={deliveryLocationBannerContent.text}
          allLocalesLabel={deliveryLocationBannerContent.allLocalesLabel}
          gotoLabel={deliveryLocationBannerContent.gotoLabel}
          currentProduct={currentProduct}
          languageAlternates={languageAlternates}
        />
      )}
      {(lg || !available) && leadIn && <LeadInBanner leadInJson={leadIn} />}
      <Header />
      <MainMenu
        languageAlternates={languageAlternates}
        contactAreaType={contactAreaType}
        mainMenuItems={mainMenuItems}
        currentProduct={currentProduct}
      />
    </>
  );
};
